import React from "react";
import ButtonSelect from "./common/ButtonSelect";

export const CssTransitionWidget = ButtonSelect.withOptions([
	{ value: 'none', label: "None" },
	{ value: '0.2s linear', label: "Linear" },
	{ value: '0.2s ease-in-out', label: "Ease" }
]);



// WEBPACK FOOTER //
// ./src/common/form/widgets/CssTransitionWidget.tsx